module.exports = __webpack_public_path__ + "static/media/maq.8d84a821.png";